/* tslint:disable */
import {
  UserAccount
} from '../index';

declare var Object: any;
export interface TokenInterface {
  "tokenTypeId": number;
  "name"?: string;
  "displayName"?: string;
  "code"?: string;
  "body"?: any;
  "data": any;
  "active": number;
  "ownerUserAccountId": number;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
  tokenType?: any;
  ownerUserAccount?: UserAccount;
}

export class Token implements TokenInterface {
  "tokenTypeId": number;
  "name": string;
  "displayName": string;
  "code": string;
  "body": any;
  "data": any;
  "active": number;
  "ownerUserAccountId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  tokenType: any;
  ownerUserAccount: UserAccount;
  constructor(data?: TokenInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Token`.
   */
  public static getModelName() {
    return "Token";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Token for dynamic purposes.
  **/
  public static factory(data: TokenInterface): Token{
    return new Token(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Token',
      plural: 'Tokens',
      path: 'Tokens',
      idName: 'id',
      properties: {
        "tokenTypeId": {
          name: 'tokenTypeId',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "body": {
          name: 'body',
          type: 'any'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "active": {
          name: 'active',
          type: 'number',
          default: 1
        },
        "ownerUserAccountId": {
          name: 'ownerUserAccountId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        tokenType: {
          name: 'tokenType',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'tokenTypeId',
          keyTo: 'id'
        },
        ownerUserAccount: {
          name: 'ownerUserAccount',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'ownerUserAccountId',
          keyTo: 'id'
        },
      }
    }
  }
}
